import moment from "moment"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetDailyReportListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    selectedDevice: CustomSingleSelectModel | undefined
    startDateStr?: string
    endDateStr?: string
    startDate?: string
    endDate?: string
    columnChooser: ColumnChooserModel[] | undefined,
    currentPage: number
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
}

export const initialGetDailyReportListPagingAndFilterRequest: GetDailyReportListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    startDate: undefined,
    endDate: undefined,
    selectedDevice: undefined,
    startDateStr: moment().format('YYYY-MM-DD 00:00'),
    endDateStr: moment().format('YYYY-MM-DD 23:59'),
    columnFilters: []
}